const Config = {
  API_URL:
    import.meta.env.VITE_API_URL || 'https://wbd-backend-7gvs.onrender.com',
  CLIENT_URL: import.meta.env.VITE_CLIENT_URL,
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT
}

export default Config
